"use client";

/**
 * "Ask me things like:" — the chips under an empty thread, or under Sabine's
 * opening message before the person has asked anything. Each is a string or
 * `{ label, prompt }`; picking one sends it.
 */
export default function AIChatSuggestedPrompts({ prompts, disabled, onPick }) {
  if (!prompts?.length) return null;
  return (
    <div className="space-y-2 pt-1">
      <p className="text-xs font-medium text-slate-400">Ask me things like:</p>
      <div className="flex flex-wrap gap-2">
        {prompts.map((option, index) => {
          const label =
            typeof option === "string"
              ? option
              : option?.label || option?.prompt || "";
          const prompt =
            typeof option === "string"
              ? option
              : option?.prompt || option?.label || "";
          if (!label || !prompt) return null;
          return (
            <button
              key={`${label}-${index}`}
              type="button"
              onClick={() => onPick(prompt)}
              disabled={disabled}
              data-testid="ai-chat-suggested-prompt"
              className="rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-xs font-medium text-slate-700 transition-colors hover:border-orange-200 hover:bg-orange-50/50 hover:text-brand-700"
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
